import { HourglassOutlined } from '@ant-design/icons';
import { type NodeProps, Position } from '@xyflow/react';
import WaitNodeMenu from 'automations/components/Nodes/WaitNodeMenu';
import { nodeSchemas, type WaitNodeType } from 'automations/types/nodeTypes';
import { getErrorList } from 'automations/utils/zod';
import dayjs from 'dayjs';
import { useMemo } from 'react';

import { type ConditionNodeReturnProps } from './useConditionNodeConfig';

export const DEFAULT_HANDLE_ID = 'default';

export default function useWait(node: NodeProps<WaitNodeType>): ConditionNodeReturnProps {
  const errorMessages = useMemo(() => getErrorList(nodeSchemas.WaitNodeData, node.data), [node.data]);
  const AdditionalUI = useMemo(() => <WaitNodeMenu node={node} />, [node]);

  const subTitle = useMemo(() => {
    const waitData = node.data?.additionalOptions?.wait;
    if (waitData?.type === 'custom') {
      if (dayjs(waitData.custom).isValid()) {
        return `Wait until ${dayjs(waitData.custom).format('DD MMM YYYY, hh:mm A')}`;
      } else {
        return `Wait until ${waitData.custom}`;
      }
    } else if (waitData?.type === 'for') {
      return `Wait for ${waitData.for.offset} ${waitData.for.unit}`;
    }
    return 'Wait';
  }, [node.data.additionalOptions]);

  return {
    subTitle,
    icon: HourglassOutlined,
    hasErrors: errorMessages.length > 0,
    errorMessages,
    targetHandle: {
      type: 'target',
      position: Position.Bottom,
      id: DEFAULT_HANDLE_ID,
    },
    AdditionalUI,
  };
}
